import { IntakeLabelCollection } from '../../entities/intake-label.interface';
import { ProgramList } from '../../constants/program-list';

const diaName = ProgramList.dia;
const aishName = ProgramList.aish;
const adapName = ProgramList.adap;
const incomeSupportName = ProgramList.incomeSupport;

const medicalReportFormLink = `<a href="./assets/documents/DS2444B.pdf" download>${diaName.abbreviation} Medical Report form</a>`;

export const AishMedicalLabels: IntakeLabelCollection = {
  medicalReportIntro: {
    label: `As part of this application you must submit a ${diaName.abbreviation} Medical Report.`,
    onBehalfLabel: `As part of this application you must submit a ${diaName.abbreviation} Medical Report for <<oboName>>.`,
  },
  downloadMedicalReportForm: {
    label: `Download the ${medicalReportFormLink} and ask your health professional to complete it. It is recommended you provide the form to your health professional as soon as possible, as it is often the part of the application that takes the longest to complete.`,
    onBehalfLabel: `Download the ${medicalReportFormLink} and ask their health professional to complete it. It is recommended you provide the form to their health professional as soon as possible, as it is often the part of the application that takes the longest to complete.`,
  },
  healthProfessionalFee: {
    label: `Health professionals may charge a fee to complete the form. You are responsible to pay this fee.`,
  },
  incomeSupportFee: {
    label: `If you are receiving ${incomeSupportName.fullName}, talk to your worker to discuss accessing a payment to cover the health professional's fee for completing this form.`,
    onBehalfLabel: `If <<oboName>> is receiving ${incomeSupportName.fullName}, talk to their worker to discuss accessing a payment to cover the health professional's fee for completing this form.`,
  },
  adapTransitionCoverage: {
    label: `If you have been transitioned to ${adapName.abbreviation} as of July 2026 and are reapplying to be reassessed for ${aishName.abbreviation}, the Alberta Government will cover the cost of one ${diaName.abbreviation} Medical Report.`,
    onBehalfLabel: `If <<oboName>> has been transitioned to ${adapName.abbreviation} as of July 2026 and is reapplying to be reassessed for ${aishName.abbreviation}, the Alberta Government will cover the cost of one ${diaName.abbreviation} Medical Report.`,
  },
  submittingReportTitle: {
    label: 'Submitting your report',
    onBehalfLabel: 'Submitting the report',
  },
  healthProfessionalCan: {
    label: 'Your health professional can:',
    onBehalfLabel: `<<oboName>>'s health professional can:`,
  },
  sendReportDirectly: {
    label: `Send the report and any supporting documents directly to ${diaName.abbreviation} Application Processing Centre, and provide you with a copy,`,
  },
  giveReportToApplicant: {
    label: 'Give the report and documents to you to attach on this page of your application.',
    onBehalfLabel: 'Give the report and documents to you to attach on this page of their application.',
  },
  isDoctorSubmittingReport: {
    label: `Is your health professional submitting your ${diaName.abbreviation} medical report directly to the ${diaName.abbreviation} Application Processing Centre?`,
    onBehalfLabel: `Is <<oboName>>'s health professional submitting their ${diaName.abbreviation} medical report directly to the ${diaName.abbreviation} Application Processing Centre?`,
    // alternateLabel: `Is your doctor and/or specialist submitting your ${diaName.abbreviation} medical report directly to ${diaName.abbreviation}?`,
  },
  hasAdditionalDocuments: {
    label: 'Are there additional medical documents that you want to include with your application?',
    onBehalfLabel: `Are there additional medical documents that you want to include with <<oboName>>'s application?`,
  },
  uploadIllnessDocument: {
    label: 'Upload a Medical document confirming your illness',
    onBehalfLabel: `Upload a Medical document confirming <<oboName>>'s illness`,
  },
  uploadSupportiveLivingDocument: {
    label: 'Upload a Medical document confirming your need for continuing care or supportive living',
    onBehalfLabel: `Upload a Medical document confirming <<oboName>>'s need for continuing care or supportive living`,
  },
  uploadIllnessAndSupportiveLivingDocument: {
    label: 'Upload Medical documents confirming your illness and your need for continuing care or supportive living',
    onBehalfLabel: `Upload Medical documents confirming <<oboName>>'s illness and their need for continuing care or supportive living`,
  },
  scanMedicalDocument: {
    label: 'Scan or take a picture of your medical document/letter to include it as part of your application.',
    onBehalfLabel: `Scan or take a picture of <<oboName>>'s medical document/letter to include it as part of their application.`,
  },
};
